import { RuleId } from '@wix/a11y-rules';
import { useCallback } from 'react';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
import { useColorContrastFixer } from './use-color-contrast-fixer';
export const useColorContrastAnalytics = _ref => {
  let {
    elements,
    failedElements,
    pageId
  } = _ref;
  const biLogger = useBiLogger();
  const {
    isColorContrastGenericComponentForeground,
    isColorContrastGenericComponentBackground,
    getComponent
  } = useColorContrastFixer({
    elements,
    numOfElements: elements.length,
    pageId
  });
  const manualTaskDataEvent = useCallback(() => {
    const componentTypeMap = new Map();
    elements.forEach(element => {
      const {
        elementId,
        affectingAncestors,
        className
      } = element;
      const isGeneric = isColorContrastGenericComponentForeground(elementId, className ?? '') || ((affectingAncestors == null ? void 0 : affectingAncestors.some(_ref2 => {
        let [id,, ancestorClassName] = _ref2;
        return isColorContrastGenericComponentBackground(id, ancestorClassName ?? '');
      })) ?? true);
      let compType;
      try {
        ({
          type: compType
        } = getComponent(elementId));
      } catch (e) {
        console.error(e);
      }
      compType = compType || 'unknown';
      if (isGeneric) {
        if (!componentTypeMap.has(compType)) {
          componentTypeMap.set(compType, {
            element_count: 0,
            failed_element_count: 0
          });
        }
        const currentData = componentTypeMap.get(compType);
        const updatedData = {
          element_count: currentData.element_count + 1,
          failed_element_count: element.isValid ? currentData.failed_element_count : currentData.failed_element_count + 1
        };
        componentTypeMap.set(compType, updatedData);
      }
    });
    const genericElementsData = Array.from(componentTypeMap.entries()).map(_ref3 => {
      let [compType, counts] = _ref3;
      return {
        comptype: compType,
        element_count: counts.element_count,
        failed_element_count: counts.failed_element_count
      };
    });
    const manualElementCount = genericElementsData.reduce((sum, item) => sum + item.element_count, 0);
    const manualFailedElementCount = genericElementsData.reduce((sum, item) => sum + item.failed_element_count, 0);
    biLogger.manualTaskData({
      elementCount: elements.length,
      failedElementCount: failedElements.length,
      genericElementsData: JSON.stringify(genericElementsData),
      manualElementCount,
      manualFailedElementCount,
      taskName: RuleId.COLOR_CONTRAST
    });
  }, [biLogger, elements, failedElements, getComponent, isColorContrastGenericComponentForeground, isColorContrastGenericComponentBackground]);
  return {
    manualTaskDataEvent
  };
};
//# sourceMappingURL=use-color-contrast-analytics.js.map